function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M7.34.25L4.247 4.733H.25v9.314h12.071l1.703-2.976.022-.041V4.733h-3.362V.25H7.34zM5.082 5.453l2.835-4.106h1.671v4.482h3.363v4.91l-1.264 2.212H5.083V5.453zM1.346 12.95h2.64V5.829h-2.64v7.122z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M5.082 12.95V5.452l2.834-4.106h1.673V5.83h3.361v4.91l-1.264 2.211H5.082zm-3.735 0h2.639V5.83H1.347v7.12zm9.339-8.218V.25H7.34L4.246 4.732H.25v9.315h12.073l1.701-2.977.023-.04V4.732h-3.361z"
}));

var SvgVote = function SvgVote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vote.5fd053f7.svg";
export { ForwardRef as ReactComponent };